/**
 * Medication unit constants and helper types
 * These are the 21 standardized medication units used throughout the application
 */

export const MEDICATION_UNITS = {
  1: 'Gram (g)',
  2: 'Milligram (mg)',
  3: 'Microgram (µg or mcg)',
  4: 'Nanogram (ng)',
  5: 'Kilogram (kg)',
  6: 'Liter (L)',
  7: 'Milliliter (mL)',
  8: 'Microliter (µL)',
  9: 'mg/mL',
  10: 'µg/mL',
  11: 'mg/L',
  12: 'mg/kg',
  13: 'µg/kg',
  14: 'mg/kg/day',
  15: 'mg/m²',
  16: 'International Unit (IU)',
  17: 'Unit (U)',
  18: 'Kilounit (kU)',
  19: 'Megunit (MU)',
  20: 'Milliequivalent (mEq)',
  21: 'Millimole (mmol)',
} as const;

/**
 * Array of medication unit options for dropdowns
 */
export const MEDICATION_UNIT_OPTIONS = Object.entries(MEDICATION_UNITS).map(([id, label]) => ({
  id: Number(id),
  label,
}));

/**
 * Type helper for medication unit IDs
 */
export type MedicationUnitId = keyof typeof MEDICATION_UNITS;
